import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

export default () => {
  const presenter = useLocalStore(() => ({
    get group() {
      return Entities.GroupsStore.getGroupById(Entities.ActiveStream.stream?.groupId);
    },

    get stream() {
      return Entities.ActiveStream.stream;
    },

    get title() {
      return presenter.stream?.title || presenter.group.title;
    },

    get streamer() {
      return presenter.stream?.activeStreamer.streamer;
    },
  }));

  return presenter;
};
